import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../pages/home/components/Navbar';
import SiteFooter from '../../pages/home/components/SiteFooter';
import { SITE } from './site';

/** Estructura comun: navbar oscuro, contenido y footer. */
export default function PageShell({ children, className = '' }: { children: ReactNode; className?: string }) {
  return (
    <div className={`sp-page ${className}`}>
      <Navbar />
      <main>{children}</main>
      <SiteFooter />
    </div>
  );
}

interface BannerProps {
  title: string;
  description?: string;
  buttonText?: string;
  buttonLink?: string;
  image?: string;
  /** El h1 de la pagina, salvo que la pagina ya tenga otro. */
  as?: 'h1' | 'h2';
}

export function Banner({ title, description, buttonText, buttonLink, image = SITE.banner, as = 'h1' }: BannerProps) {
  const Heading = as;
  return (
    <section className="sp-banner">
      <img src={image} alt="" className="sp-banner-img" fetchPriority="high" />
      <div className="sp-banner-content">
        <img src={SITE.logo} alt="SpartechRD" className="sp-banner-logo" width={140} height={167} />
        <Heading className="sp-banner-title">{title}</Heading>
        {buttonLink && buttonText && (
          <Link to={buttonLink} className="sp-btn sp-btn-stroke">
            {buttonText}
          </Link>
        )}
        {description && <p className="sp-banner-text">{description}</p>}
      </div>
    </section>
  );
}

export function Spinner() {
  return (
    <div className="sp-spinner-wrap" role="status">
      <div className="sp-spinner" />
      <span className="sr-only">Cargando...</span>
    </div>
  );
}

/** Titulo de seccion con la segunda palabra en rojo: "Ultimos <Productos>". */
export function SectionTitle({
  children,
  accent,
  subtitle,
  as = 'h2',
}: {
  children: ReactNode;
  accent?: ReactNode;
  subtitle?: string;
  as?: 'h1' | 'h2';
}) {
  const Heading = as;
  return (
    <div style={{ marginBottom: '3rem', textAlign: 'center' }}>
      <Heading className="sp-title">
        {children} {accent && <span className="sp-accent">{accent}</span>}
      </Heading>
      {subtitle && <p className="sp-subtitle">{subtitle}</p>}
    </div>
  );
}
